import { useFormContext, useWatch } from 'react-hook-form'

import { useBroadcastClientCounts, useBroadcastSettings } from '../queries'

import type { UpdateBroadcastInputs } from '../broadcast.schema'
import { SegmentedMessage } from 'sms-segments-calculator'

type Props = { broadcastId: string }

function CreditsInfo({ broadcastId }: Props) {
  const { control } = useFormContext<UpdateBroadcastInputs>()

  const clientCounts = useBroadcastClientCounts(broadcastId)
  const broadcastSettings = useBroadcastSettings()

  const watchSmsAttachments = useWatch({ control, name: 'setAttachmentsSms' })
  const watchSmsMessage = useWatch({ control, name: 'smsMessage' })
  const segment = new SegmentedMessage(watchSmsMessage ?? '')

  const numberOfSegments = watchSmsAttachments?.length
    ? 3
    : segment.segmentsCount
  const smsClientCount = clientCounts.data?.smsClientCount

  const creditsUsed = smsClientCount
    ? watchSmsAttachments
      ? smsClientCount * 3
      : smsClientCount * numberOfSegments
    : 0

  return (
    <div className="text-center">
      <p className="text-ion-color-yellow">
        Text Credits Used on This Broadcast: {creditsUsed}
      </p>
      <p className="text-ion-color-secondary">
        Text Credits Left After:{' '}
        {!broadcastSettings.data || clientCounts.isLoading
          ? '...'
          : `${(
              broadcastSettings.data.smsCreditsRemaining - creditsUsed
            ).toLocaleString()}/${broadcastSettings.data.smsCredits.toLocaleString()}`}
      </p>
    </div>
  )
}

export { CreditsInfo }
